<template>
  <el-select
    :value="couponCode"
    class="coupon-selector"
    filterable
    placeholder="เลือก Coupon"
    @input="handleChangeCoupon"
  >
    <el-option
      v-for="item in couponOptions"
      :key="item.id"
      :label="item.textDiscount"
      :value="item.id"
      >{{ item.textDiscount }}
    </el-option>
  </el-select>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { convertBathToStangAndRoundTwoDecimal } from "@/lib/formatter";
import { Option, Select } from "element-ui";

export default {
  name: 'CouponSelect',
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    packageId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      coupons: []
    }
  },
  computed: {
    couponOptions() {
      if (!this.coupons) return []

      const coupons = this.coupons.map((coupon) => {
        const isDiscountPercent = coupon.discount_percent_amount !== null

        const discountPrice = isDiscountPercent
          ? `${coupon.discount_percent_amount}%`
          : `${convertBathToStangAndRoundTwoDecimal(coupon.discount_amount)}บาท`

        const textDiscount = `${coupon.code} (${discountPrice})`

        return {
          id: coupon.id,
          textDiscount,
          code: coupon.code
        }
      })

      return coupons;
    },
    couponCode() {
      if (!this.value) {
        return null;
      }

      const isDiscountPercent = this.value.discount_percent_amount !== null

      const discountPrice = isDiscountPercent
        ? `${this.value.discount_percent_amount}%`
        : `${convertBathToStangAndRoundTwoDecimal(this.value.discount_amount)}บาท`

      return `${this.value.code} (${discountPrice})`;
    }
  },
  watch: {
    packageId() {
      this.setupCoupons();
    }
  },
  created() {
    this.setupCoupons();
  },
  methods: {
    async setupCoupons() {
      this.$emit("selectCoupon", null);
      this.coupons = await this.fetchCoupons();
    },
    async fetchCoupons() {
      if (!this.packageId) return []

      try {
        const response = await baanRueJaiClient.admin.subscriptions.coupons.getSearch(
          this.packageId
        );

        return response.data.result;
      } catch (error) {
        return [];
      }
    },
    handleChangeCoupon(couponId) {
      const coupon = this.coupons.find(c => c.id === couponId) ?? null
      this.$emit("selectCoupon", coupon)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.coupon-selector {
  width: 100%;
}
</style>
